import React, { createContext, useContext, useState, useCallback } from 'react';
import { BnInfoPanel } from '~/common/bn-info-panel';

type BnInfoPanelContextType = {
  openPanel: (props: { title: React.ReactNode, content: React.ReactNode, classes: Record<string, string> }) => void;
  closePanel: () => void;
};

const BnInfoPanelContext = createContext<BnInfoPanelContextType | null>(null);

export function BnInfoPanelProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState(null);
  const [classes, setClasses] = useState(null);

  const openPanel = useCallback(({ title: nextTitle, content: nextContent, classes: nextClasses }) => {
    setTitle(nextTitle ?? null);
    setContent(nextContent ?? null);
    setClasses(nextClasses ?? null);
    setOpen(true);
  }, []);

  const closePanel = useCallback(() => {
    setOpen(false);
  }, []);

  const value = { openPanel, closePanel };

  return (
    <BnInfoPanelContext.Provider value={value}>
      {children}
      <BnInfoPanel
        open={open}
        setOpen={setOpen}
        content={content}
        title={title ?? null}
        classes={classes ?? {}}
      />
    </BnInfoPanelContext.Provider>
  );
}

export function useBnInfoPanel() {
  const ctx = useContext(BnInfoPanelContext);
  if (!ctx) {
    throw new Error('useBnInfoPanel must be used within BnInfoPanelProvider');
  }
  return ctx;
}
